<script>
    import { link, Link } from 'svelte-routing';
    import { getLocalizedText, getTuidFromText } from 'senselogic-gist';
    import { enabledAdminView } from '$lib/store/adminStore';
    import { languageTagStore } from '$lib/store/languageTagStore';
    import page from '../../store/pageStore';
    import { textStore } from '$lib/store/textStore';
    import Button from '../element/Button.svelte';
    import LanguageToggler from '../header/LanguageToggler.svelte';
    import MobileNavigationIcon from '../header/MobileNavigationIcon.svelte';
    import AdminEditButton from '../element/AdminEditButton.svelte';
    import { user } from '../../store/userStore';
    import Switch from '../element/Switch.svelte';

    import { onMount, onDestroy } from "svelte";

    // MOBILE NAVIGATION + RESPONSIVE BREAKPOINT
    let isMobileNavigationOpen = false;
    let isMobile = window.innerWidth <= 1200;

    function handleResize() {
        isMobile = window.innerWidth <= 1200;
        // Opcional: fechar menu ao trocar para desktop
        if (!isMobile) isMobileNavigationOpen = false;
    }

    function handleMobileNavigationButtonClick() {
        isMobileNavigationOpen = !isMobileNavigationOpen;
    }

    onMount(() => {
        window.addEventListener("resize", handleResize);
    });
    onDestroy(() => {
        window.removeEventListener("resize", handleResize);
    });

    getTuidFromText("media-menu-label");
</script>

<style lang="stylus">
    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    header
        z-index: 999
        position: sticky
        top: 0
        width: 100%
        max-width: 100vw
        border-bottom: 2px solid #2a2a2a
        padding: 1rem 2rem
        display: flex
        justify-content: space-between
        align-items: center
        background-color: darkGreyColor

        .header-logo
            max-width: 12rem
            object-fit: cover

        .header-navigation
            width: 100%
            display: flex
            justify-content: space-between

            // MOBILE
            @media (max-width: 1200px)
                position: fixed
                overflow: scroll
                inset: 0 200%
                height: 100vh
                width: 100vw
                flex-direction: column
                background-color: darkGreyColor
                transition: inset 350ms ease-in-out
                overscroll-behavior: contain

        .header-navigation.is-open
            @media (max-width: 1200px)
                inset: 0 0

        .header-navigation-links-list
            min-height: max-content
            display: flex
            flex-direction: column
            gap: 1.5rem
            align-items: flex-start
            margin-top: 5rem
            padding: 1rem 2rem

            @media (min-width: 1201px)
                flex-direction: row
                justify-content: space-between
                align-items: center
                gap: 1rem
                margin-top: 0
                margin-bottom: 0
                padding: 0 1rem

            @media (min-width: 1366px)
                gap: 1.5rem

        .header-navigation-link-container
            margin: 0
            padding: 0.75rem 0.75rem

            @media (max-width: 1200px)
                width: 100%
                border-bottom: 1px solid #2A2A2A
                padding: 1rem 0

            // &.tablet-hidden
            //     @media (min-width: 1201px)
            //         display: none
            //     @media (min-width: 1300px)
            //         display: block

        :global( .header-navigation-link )
            font-size: 1rem
            font-weight: 250
            letter-spacing: 0.1rem
            text-transform: uppercase
            color: lightGreyColor
            cursor: pointer
            transition: all 0.1s ease-in-out

            @media (max-width: 1200px)
                line-height: 2rem
                font-size: 1.5rem

        :global( .header-navigation-link:hover )
            color: lightGoldColor

    .buttons-container
        display: flex
        align-items: flex-start
        flex-direction: column
        padding: 1rem 2rem 6rem
        gap: 2rem

        @media (min-width: 1201px)
            gap: 1.5rem;
            padding: 0 1rem
            display: flex
            align-items: center
            flex-direction: row

        .admin-toggle
            display: none

            @media (min-width: 1201px)
                display: block

    .new-tag
        position: relative
        
        &::after
            z-index: 2
            position: absolute
            top: -0.625rem
            left: calc(100% - 0.125rem)
            content: "new"
            border-radius: 0.25rem
            padding: 0.0625rem 0.125rem
            background-color: lightGoldColor
            color: darkGreyColor
            font-weight: bold
            font-size: 0.625rem

        @media (max-width: 1200px)
            &::after
                padding: 0.0313rem 0.0625rem
                line-height: 1.25rem

    .mobile-navigation-button
        outline: none
        height: 3rem
        width: 3rem
        border: none
        display: none
        background-color: unset
        cursor: pointer

        @media (max-width: 1200px)
            z-index: 999
            display: block
</style>

<header>
    <Link
        to="/{ $languageTagStore }"
        on:click={ () => isMobileNavigationOpen = false }
    >
        <img class="header-logo" src="/image/icon/logo.svg" alt="logo"/>
    </Link>
    
    <nav class="header-navigation" class:is-open={ isMobileNavigationOpen } class:is-mobile={ isMobile }>
        <div></div>
        <ul class="header-navigation-links-list">
            {#key $textStore[ 'team-menu-label' ]}
                <li class="header-navigation-link-container" class:is-admin-enabled={ $enabledAdminView }>
                    <Link
                        class="header-navigation-link"
                        to="/{ $languageTagStore }/team"
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                        { getLocalizedText( $textStore[ 'team-menu-label' ] || '', $languageTagStore ) }
                    </Link>
                    <AdminEditButton
                        isMultiline={ false }
                        type="text"
                        slug="team-menu-label"
                        textToEdit={ $textStore[ 'team-menu-label' ] }
                    />
                </li>
            {/key}

            {#key $textStore[ 'networking-menu-label' ]}
                <li class="header-navigation-link-container" class:is-admin-enabled={ $enabledAdminView }>
                    <Link
                        class="header-navigation-link"
                        to="/{ $languageTagStore }/networking"
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                        { getLocalizedText( $textStore[ 'networking-menu-label' ] || '', $languageTagStore ) }
                    </Link>
                    <AdminEditButton
                        isMultiline={ false }
                        type="text"
                        slug="networking-menu-label"
                        textToEdit={ $textStore[ 'networking-menu-label' ] }
                    />
                </li>
            {/key}

            {#key $textStore[ 'partners-bamhub-menu-label' ]}
                <li class="header-navigation-link-container" class:is-admin-enabled={ $enabledAdminView }>
                    <Link
                        class="header-navigation-link"
                        to="/{ $languageTagStore }/partners"
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                        { getLocalizedText( $textStore[ 'partners-bamhub-menu-label' ] || '', $languageTagStore ) }
                    </Link>
                    <AdminEditButton
                        isMultiline={ false }
                        type="text"
                        slug="partners-bamhub-menu-label"
                        textToEdit={ $textStore[ 'partners-bamhub-menu-label' ] }
                    />
                </li>
            {/key}

            {#key $textStore[ 'hubs-menu-label' ]}
                <li class="header-navigation-link-container" class:is-admin-enabled={ $enabledAdminView }>
                    <Link
                        class="header-navigation-link"
                        to="/{ $languageTagStore }/hubs"
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                        { getLocalizedText( $textStore[ 'hubs-menu-label' ] || '', $languageTagStore ) }
                    </Link>
                    <AdminEditButton
                        isMultiline={ false }
                        type="text"
                        slug="hubs-menu-label"
                        textToEdit={ $textStore[ 'hubs-menu-label' ] }
                    />
                </li>
            {/key}

            {#key $textStore[ 'what-is-bamhub-menu-label' ]}
                <li class="header-navigation-link-container" class:is-admin-enabled={ $enabledAdminView }>
                    <Link
                        class="header-navigation-link"
                        to="/{ $languageTagStore }/what-is-bamhub"
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                        { getLocalizedText( $textStore[ 'what-is-bamhub-menu-label' ] || '', $languageTagStore ) }
                    </Link>
                    <AdminEditButton
                        isMultiline={ false }
                        type="text"
                        slug="what-is-bamhub-menu-label"
                        textToEdit={ $textStore[ 'what-is-bamhub-menu-label' ] }
                    />
                </li>
            {/key}

            {#key $textStore[ 'media-menu-label' ]}
                <li class="header-navigation-link-container" class:is-admin-enabled={ $enabledAdminView }>
                    <a
                        class="header-navigation-link new-tag"
                        href="https://www.bamhub.media/"
                        target="_blank"
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                        { getLocalizedText( $textStore[ 'media-menu-label' ] || '', $languageTagStore ) }
                    </a>

                    <AdminEditButton
                        isMultiline={ false }
                        type="text"
                        slug="media-menu-label"
                        textToEdit={ $textStore[ 'media-menu-label' ] }
                    />
                </li>
            {/key}

            {#key $textStore[ 'news-menu-label' ]}
                <li class="header-navigation-link-container tablet-hidden" class:is-admin-enabled={ $enabledAdminView }>

                    <Link
                        class="header-navigation-link"
                        to="/{ $languageTagStore }/news"
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                        { getLocalizedText( $textStore[ 'news-menu-label' ] || '', $languageTagStore ) }
                    </Link>
                    
                    <AdminEditButton
                        isMultiline={ false }
                        type="text"
                        slug="news-menu-label"
                        textToEdit={ $textStore[ 'news-menu-label' ] }
                    />
                </li>
            {/key}

            {#key $textStore[ 'faq-menu-label' ]}
                <li class="header-navigation-link-container tablet-hidden" class:is-admin-enabled={ $enabledAdminView }>
                    <Link
                        class="header-navigation-link"
                        to="/{ $languageTagStore }/FAQ"
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                        { getLocalizedText( $textStore[ 'faq-menu-label' ] || '', $languageTagStore ) }
                    </Link>
                   
                    <AdminEditButton
                        isMultiline={ false }
                        type="text"
                        slug="faq-menu-label"
                        textToEdit={ $textStore[ 'faq-menu-label' ] }
                    />
                </li>
            {/key}
        </ul>

        <ul class="buttons-container">
            {#key $page.url.href}
                <li class:is-admin-enabled={ $enabledAdminView }>
                <LanguageToggler bind:isMobileNavigationOpen />
                <AdminEditButton
                    type="language"
                    title="language"
                    inset="-1.25rem 1rem auto auto"
                />
                </li>
            {/key}

            {#if $user}
                {#if $user.role === 'authenticated'}
                    <li class="admin-toggle">
                        <p class="font-size-100 text-align-center">Admin</p>
                        <Switch bind:value={ $enabledAdminView }/>
                    </li>
                {/if}
            {/if}

            {#key $textStore[ 'become-a-member-button' ]}
                <li class:is-admin-enabled={ $enabledAdminView }>
                <a href={ `/${ $languageTagStore }/become-member` } use:link>
                    <Button
                        fullWidth={ false }
                        on:click={ () => isMobileNavigationOpen = false }
                    >
                    { getLocalizedText( $textStore[ 'become-a-member-button' ], $languageTagStore ) }
                    </Button>
                </a>
                <AdminEditButton
                    isMultiline={ false }
                    type="text"
                    slug="become-a-member-button"
                    textToEdit={ $textStore[ 'become-a-member-button' ] }
                />
                </li>
            {/key}
        </ul>
    </nav>
    
    <button
        class="mobile-navigation-button"
        aria-label="Menu"
        on:click={handleMobileNavigationButtonClick}
        style="display:{isMobile ? 'block' : 'none'}"
    >
        <MobileNavigationIcon { isMobileNavigationOpen } />
    </button>
</header>
